import Typography, { TypographyProps } from './Typography';
export default Typography;
export type { TypographyProps };
export * from './Typography.styles';
